export default "__VITE_ASSET__C5XVi645__"